import { useCallback, useContext } from "react";
import MatomoContext from "../context/MatomoContext";
export default function useMatomo() {
  const instance = useContext(MatomoContext);
  const trackPageView = useCallback(params => instance === null || instance === void 0 ? void 0 : instance.trackPageView(params), [instance]);
  const trackEvent = useCallback(params => instance === null || instance === void 0 ? void 0 : instance.trackEvent(params), [instance]);
  return {
    trackPageView,
    trackEvent
  };
}